import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface VirtualIbanBrand {
    readonly VirtualIban: unique symbol;
}
export const VirtualIban = brand(
    NonEmptyString,
    (n): n is Branded<NonEmptyString, VirtualIbanBrand> => /^[A-Z0-9]+$/.test(n),
    'VirtualIban'
);
export type VirtualIban = TypeOf<typeof VirtualIban>;
